<template>
  <div class="app-container">
    <StockCorrectionList entity="StockCorrection" />
  </div>
</template>

<script>
import StockCorrectionList from './components/StockCorrectionList';
export default {
  components: {
    StockCorrectionList
  }
};
</script>
